import { render, staticRenderFns } from "./ac-collection-card.vue?vue&type=template&id=5589a86b&"
import script from "./ac-collection-card.vue?vue&type=script&lang=js&"
export * from "./ac-collection-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports